import React, { Component } from 'react';
import Switch from '../../../../Part_Sample/Switch';
import Select from '../../../../Part_Sample/Select';
import { makeTimeString, isEmpty } from '../../../../Common/Common';

export default class Setback extends Component {
	constructor(props) {
		super(props);
		let sb_csp = 24;
		let sb_hsp = 10;

		if (!isEmpty(this.props.point_info)) {
			sb_csp = this.props.point_info.sb_csp;
			sb_hsp = this.props.point_info.sb_hsp;
		}

		this.state = {
			sb_csp: sb_csp,
			sb_hsp: sb_hsp,
		}
	}

	handleChangeSBCool = (val) => {
		this.setState({ sb_csp: val });

		if (val !== '--') val = parseFloat(val);
		this.props.handleChangeSetbackCool(val);
	}

	handleChangeSBHeat = (val) => {
		this.setState({ sb_hsp: val });

		if (val !== '--') val = parseFloat(val);
		this.props.handleChangeSetbackHeat(val);
	}

	render() {
		const setBackCoolRange = [];
		const setBackHeatRange = [];

		setBackCoolRange.push(<option value={'--'} key={'setBackCool'}>--</option>);
		setBackHeatRange.push(<option value={'--'} key={'setBackHeat'}>--</option>);

		for (var j = 24; j < 36; j++) {
			setBackCoolRange.push(<option value={j} key={'setBackCool-' + j}>{j}</option>);
		}

		for (var k = 10; k < 21; k++) {
			setBackHeatRange.push(<option value={k} key={'setBackHeat-' + k}>{k}</option>);
		}

		return (
			<div id='setback' style={this.props.style}>
				<div style={{ padding: 10, }}>
					<div style={{ marginLeft: 10 }}>
						<span> {this.props.receiver.getString('setback')} </span>
					</div>
					<div id='setback_cool'>
						<div style={{ display: 'inline-block', marginLeft: 10, width: this.props.width - 110 }}>
							<span> {this.props.receiver.getString('cool')} </span>
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setBackCoolRange}
									value={this.state.sb_csp}
									onSelect={this.handleChangeSBCool}
								/>
							</div>
						</div>
					</div>
					<div id='setback_heat'>
						<div style={{ display: 'inline-block', marginLeft: 10, width: this.props.width - 110 }}>
							<span> {this.props.receiver.getString('heat')} </span>
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
							<div style={{ display: 'inline-block', marginLeft: 10, width: 60 }}>
								<Select
									options={setBackHeatRange}
									value={this.state.sb_hsp}
									onSelect={this.handleChangeSBHeat}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}